module.exports = "/img/11.6f1c16.webp";